// VariableContext.js
import React from 'react';

const FetchingFreq = React.createContext();

export default FetchingFreq;
